import { render, staticRenderFns } from "./material-info-table.vue?vue&type=template&id=a7e18a06&scoped=true"
import script from "./material-info-table.vue?vue&type=script&setup=true&lang=js"
export * from "./material-info-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-info-table.vue?vue&type=style&index=0&id=a7e18a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e18a06",
  null
  
)

export default component.exports